<template>
  <!-- 电废一楼，全部信息 -->
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:'+screenHeight">
        <div class="left-content slip_out_animation"  style="height:40%">
          <div class="type-title">
            <div>产出物总量：494吨</div>
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
        <div class="left-content slip_out_animation" style="height:60%">
          <div class="type-title">
            <div>产出物占比</div>
          </div>
          <div class="left-echarts-2" id="left-echarts-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsRightBottom();
      });
    }, 300);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");
      var myChart = echarts.init(leftEchartsTOP);
      var option;
      var allnumber = 0;
      option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + ":  " + params.data.value;
          },
        },
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "43%",
            style: {
              text: `3147吨`,
              textAlign: "center",
              fill: "#FFF", //文字的颜色
              width: 30,
              height: 30,
              fontSize: 16,
              color: "#4d4f5c",
              fontFamily: "Microsoft YaHei",
            },
          },
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "53%",
            style: {
              text: `总计`,
              textAlign: "center",
              fill: "#FFF", //文字的颜色
              width: 30,
              height: 30,
              fontSize: 12,
              color: "#4d4f5c",
              fontFamily: "Microsoft YaHei",
            },
          },
        ],

        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          show: false,
          bottom: 0,
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["30%", "50%"],
            data: [
              { value: 1048, name: "冰箱" },
              { value: 735, name: "电视" },
              { value: 580, name: "空调" },
              { value: 484, name: "洗衣机" },
              { value: 300, name: "电脑" },
            ],
            label: {
              color: "#FFF",
              formatter(param) {
                return param.percent + "%";
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          show: false,
        },
        grid: {
          left: 80, // 调整这个属性
          top:0,
          bottom:20
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          axisLabel: {
            color: "#fff",
          },
          type: "category",
          data: [
            "冷凝器",
            "空调点击偏转",
            "铝电机",
            "铜电机",
            "离合器",
            "空调塑料",
            "电视塑料",
            "洗衣机塑料",
          ],
        },
        series: [
          {
            name: "",
            type: "bar",
            data: [18, 23, 29, 104, 131, 30, 99, 60],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
    <style scoped>
.main .left {
  width: 21.5vw;

  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  height: 50%;
}
::v-deep .main .left .left-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main .left .left-content .video-content {
  width: 100%;
}

.main .left .left-content .video-content video {
  width: 100%;
}

.main .left .left-content .company-content {
  line-height: 40px;
  font-size: 18px;
  height: 51vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  min-height: 90%;
}
</style>
    